module.exports = __webpack_public_path__ + "img/btn.193d2519.png";